import { useMemo } from 'react'

import { DEFAULT_PROPS } from './data'

export function useParsedCarouselData(componentProps: string) {
  const carouselData = useMemo(() => {
    try {
      const parsedComponentProps = JSON.parse(componentProps || '{}')

      return {
        ...DEFAULT_PROPS,
        ...parsedComponentProps,
      }
    } catch (error) {
      console.error('[LightCarousel]', error)

      return DEFAULT_PROPS
    }
  }, [componentProps])

  return carouselData
}
